export const navbar = [
    // {
    //     value: 'Home',
    //     link: '#',
    //     subMenu: [{}],
    // },
    // {
    //     value: 'Start Here',
    //     link: '#',
    //     subMenu: [{}],
    // },
    // {
    //     value: 'What Makes Us Unique',
    //     link: '#',
    //     subMenu: [
    //         {
    //             value: 'Learn While You Get Real Strategy Work Done',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },
    //         {
    //             value: 'Our People',
    //             link: '#',
    //             sub: [
    //                 {
    //                     value: 'Mary Abbazia',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Mel Ingold',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Martin Ma',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Tom Spitale',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Tom Niehaus',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Paul DiPrato',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Sean Welham',
    //                     link: '#',
    //                 },
    //                 {
    //                     value: 'Debby Pratt',
    //                     link: '#',
    //                 },
    //             ],
    //             subClassName: 'sub1',
    //         },
    //         {
    //             value: 'Our Approach',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },
    //         {
    //             value: 'Our Process',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },
    //     ],
    // },
    // {
    //     value: 'Problems We Solve',
    //     link: '',
    //     subMenu: [
    //         {
    //             value: 'Specific Issues We Address',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },
    //         {
    //             value: 'How We Help Companies Like Yours',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },
    //         {
    //             value: 'Current and Recent Projects',
    //             link: '#',
    //             sub: [
    //                 {
    //                     value: 'For Entrepreneur Companies',
    //                     link: '#'
    //                 },
    //                 {
    //                     value: 'For Marketing Machine Companies',
    //                     link: '#'
    //                 },
    //                 {
    //                     value: 'For Product/Sales Focused Companies',
    //                     link: '#'
    //                 },
    //                 {
    //                     value: 'For Business Scientist Companies',
    //                     link: '#'
    //                 },
    //             ],
    //             subClassName: 'sub2',
    //         },
    //     ],
    // },
    // {
    //     value: 'Proven Results',
    //     link: '',
    //     subMenu: [
    //         {
    //             value: 'Case Studies',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },            {
    //             value: 'Testimonials',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },            {
    //             value: 'Client List',
    //             link: '#',
    //             sub: [{}],
    //             subClassName: '',
    //         },
    //     ],
    // },
    // {
    //     value: 'Our Latest Thinking ',
    //     link: '#',
    //     subMenu: [{}],
    // },
    // {
    //     value: 'Contact Us',
    //     link: '#',
    //     subMenu: [{}],
    // },
    {
        value: 'Login',
        link: '/login',
        subMenu: [{}],
    },
]







// WEBPACK FOOTER //
// ./src/components/Home/HomePageHeader/NavbarData.js